import { BdsPaper, BdsTypo } from 'blip-ds/dist/blip-ds-react';
import React, { useContext, useMemo } from 'react';
import DailyEngagedUsersContext from '../../../contexts/DailyEngagedUsersContext';
import {
  CompiledDailyEngagedUsersWithLineRow,
  DailyEngagedUserConsumptionConsolidatedHeaderPartial,
  DailyEngagedUserConsumptionConsolidatedHeaderRow,
} from '../styles';
import { DateDropdown } from '../../../components/DateDropdown';
import { DAILY_ACTIVE_USERS_PERIOD_SELECT } from '../../../shared/SegmentEvents';
import { createTrack } from '../../../api/SegmentApi';
import { getFirstDayOfSpecifiedMonth, getLastDayOfSpecifiedMonth, toUTCDateString } from '../../../utils/date';

const CompiledDailyEngagedUserTitleComponent: React.FC = () => {
  const {
    currentMonth,
    content,
    tenant,
    loggedUser,
    setDateToSearch,
    dateToSearch,
    periodOptions,
    compiledDailyEngagedUserDataState,
  } = useContext(DailyEngagedUsersContext);

  const dateContent = useMemo(() => {
    return content.formatString(content.compiledDailyEngagedUserInformation.about,
      toUTCDateString(getFirstDayOfSpecifiedMonth(dateToSearch), content.locale, true),
      toUTCDateString(
        currentMonth ? new Date() : getLastDayOfSpecifiedMonth(dateToSearch),
        content.locale,
      ),
    );
  }, [compiledDailyEngagedUserDataState]);

  const periodOptionChangeEvent = async (selectedOption) => {
    const dateToRetrieveData = new Date(selectedOption.detail.value);
    setDateToSearch(dateToRetrieveData);
    createTrack(tenant.info, DAILY_ACTIVE_USERS_PERIOD_SELECT, {
      dauDate: dateToRetrieveData.getFullYear() + '-' + ('0' + (dateToRetrieveData.getMonth() + 1)).slice(-2),
      dauUser: loggedUser.email,
    });
  };

  return (
    <DailyEngagedUserConsumptionConsolidatedHeaderRow>
      <CompiledDailyEngagedUsersWithLineRow>
        <div>
          <DailyEngagedUserConsumptionConsolidatedHeaderPartial>
            <BdsTypo className="title" tag="h3" variant="fs-24" bold="bold" margin={false}>
              {content.formatString(
                content.compiledDailyEngagedUserInformation.title,
                content.compiledDailyEngagedUserInformation.month[dateToSearch.getMonth()],
              )}
            </BdsTypo>
            {currentMonth && (
              <BdsPaper className="partialUsage" elevation="static">
                <BdsTypo variant="fs-12" bold="semi-bold">
                  {content.compiledDailyEngagedUserInformation.partialUsage}
                </BdsTypo>
              </BdsPaper>
            )}
          </DailyEngagedUserConsumptionConsolidatedHeaderPartial>
          <BdsTypo className="subtitle" variant="fs-14">
            {dateContent}
          </BdsTypo>
        </div>
        <DateDropdown
          value={dateToSearch.toISOString()}
          bdsChangeEvent={periodOptionChangeEvent}
          options={periodOptions}
          label={content.monthPlaceholder}
        ></DateDropdown>
      </CompiledDailyEngagedUsersWithLineRow>
    </DailyEngagedUserConsumptionConsolidatedHeaderRow>
  );
};

export default CompiledDailyEngagedUserTitleComponent;
